export default { "columns":74,
 "image":"VP2_Main.png",
 "imageheight":768,
 "imagewidth":1184,
 "margin":0,
 "name":"vp2main",
 "spacing":0,
 "tilecount":3552,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":411,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":8,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":16,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":412,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-8,
                             "y":-8
                            }, 
                            {
                             "x":-16,
                             "y":-8
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":485,
         "type":"platform"
        }, 
        {
         "id":486,
         "type":"platform"
        }, 
        {
         "id":487,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":561,
         "type":"platform"
        }, 
        {
         "id":562,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":8,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":563,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":8,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":16,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":564,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":8,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":16,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":636,
         "type":"platform"
        }, 
        {
         "id":637,
         "type":"platform"
        }, 
        {
         "id":638,
         "type":"platform"
        }, 
        {
         "id":2120,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2121,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2122,
         "type":"platform"
        }, 
        {
         "id":2123,
         "type":"platform"
        }, 
        {
         "id":2124,
         "type":"platform"
        }, 
        {
         "id":2125,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2126,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2192,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":-4
                            }, 
                            {
                             "x":8,
                             "y":-8
                            }, 
                            {
                             "x":8,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":8,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2193,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-8
                            }, 
                            {
                             "x":16,
                             "y":8
                            }, 
                            {
                             "x":0,
                             "y":8
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":8
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":2194,
         "type":"platform"
        }, 
        {
         "id":2200,
         "type":"platform"
        }, 
        {
         "id":2201,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":3211,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":4,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":16,
                     "x":0,
                     "y":12
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"platform"
        }, 
        {
         "id":3212,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":4,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":16,
                     "x":0,
                     "y":12
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"Platform"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};